import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "tiny-mce-editor-block"
};
const _hoisted_2 = {
  key: 0,
  class: "action-buttons"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_tinymce_editor = _resolveComponent("tinymce-editor");
  const _component_standard_button = _resolveComponent("standard-button");
  const _component_flip_card_image_dialog = _resolveComponent("flip-card-image-dialog");
  const _component_confirm_dialog = _resolveComponent("confirm-dialog");
  return _ctx.initConfig ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_tinymce_editor, {
    id: _ctx.editorId,
    "tinymce-script-src": "/public/javascripts/tinymce/tinymce.min.js",
    init: _ctx.initConfig,
    modelValue: _ctx.liveText,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.liveText = $event),
    licenseKey: "gpl",
    onBlur: _ctx.handleBlurEvent
  }, null, 8, ["id", "init", "modelValue", "onBlur"]), _ctx.displayEditorButtons ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_ctx.cancelLabel ? (_openBlock(), _createBlock(_component_standard_button, {
    key: 0,
    class: "btn cancel-edit",
    label: _ctx.cancelLabel,
    outlined: true,
    onAction: _ctx.onCancelChanges
  }, null, 8, ["label", "onAction"])) : _createCommentVNode("", true), _ctx.saveLabel ? (_openBlock(), _createBlock(_component_standard_button, {
    key: 1,
    class: "btn save-changes",
    label: _ctx.saveLabel,
    onAction: _ctx.onSaveChanges
  }, null, 8, ["label", "onAction"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _ctx.flipCardAddImgEventTriggered ? (_openBlock(), _createBlock(_component_flip_card_image_dialog, {
    key: 1,
    onImgUpdate: _ctx.onImgUpdate,
    onDialogClose: _ctx.onFlipCardDialogClose
  }, null, 8, ["onImgUpdate", "onDialogClose"])) : _createCommentVNode("", true), _ctx.flipCardDeleteEventTriggered ? (_openBlock(), _createBlock(_component_confirm_dialog, {
    key: 2,
    visible: _ctx.flipCardDeleteEventTriggered,
    title: _ctx.$t('documentEditor.flipcard.deleteCardDialog.title'),
    message: _ctx.$t('documentEditor.flipcard.deleteCardDialog.description'),
    "confirm-button-text": _ctx.$t('documentEditor.flipcard.deleteCardDialog.validateBtn'),
    "cancel-button-text": _ctx.$t('documentEditor.flipcard.deleteCardDialog.cancelBtn'),
    "close-on-outside-click": false,
    onOnConfirmed: _cache[1] || (_cache[1] = $event => _ctx.onCardDeleteConfirm()),
    onOnDialogClose: _cache[2] || (_cache[2] = $event => _ctx.onCardDeleteCancel()),
    onOnCanceled: _cache[3] || (_cache[3] = $event => _ctx.onCardDeleteCancel())
  }, null, 8, ["visible", "title", "message", "confirm-button-text", "cancel-button-text"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true);
}